import {
  EventTracker,
  Palette,
  SeriesRef,
  Animation,
} from '@devexpress/dx-react-chart';
import {
  Chart,
  Legend,
  PieSeries,
  Tooltip,
} from '@devexpress/dx-react-chart-material-ui';
import Paper from '@material-ui/core/Paper';

import { TooltipOverlay } from 'components';
import { EMPTY_ACTIVITY_STATUS_CHART } from 'constants/planning/grafico-status-atividade';
import { useCallback } from 'react';
import Info from '@material-ui/icons/InfoOutlined';
import { defaultColors, emptyColor } from './colors/activity-status-chart';
import useStyles from './style';
import { IStyleProps } from './types';

export interface ITooltipContentProps extends Tooltip.ContentProps {
  targetItem: SeriesRef;
}

const ChartActivityStatus = ({ data, total }) => {
  const classes = useStyles({ hasData: !!data } as IStyleProps);

  const chartData = total ? data : [...EMPTY_ACTIVITY_STATUS_CHART];
  const colors = total ? defaultColors : emptyColor;

  const TooltipContent = ({ targetItem, ...props }: ITooltipContentProps) => {
    if (data && data.length && total) {
      const rawValue = data[targetItem.point].value;
      const rawLabel = data[targetItem.point].legend;
      const percentageValue = total ? (rawValue * 100) / total : 0;
      const formattedPercentageValue = percentageValue.toFixed(2);

      return (
        <Tooltip.Content
          {...props}
          targetItem={targetItem}
          text={`${rawLabel}: ${rawValue}; ${formattedPercentageValue}%`}
        />
      );
    }
    return (
      <Tooltip.Content
        {...props}
        targetItem={targetItem}
        text="Sem dados disponíveis"
      />
    );
  };

  const LabelRoot = useCallback(({ children, ...rest }) => {
    return (
      <Legend.Root {...rest}>
        {children.filter(
          (c: React.ReactElement) =>
            c.key === 'Pausadas' ||
            c.key === 'Atrasadas' ||
            c.key === 'Concluídas' ||
            c.key === 'Em Andamento' ||
            c.key === 'Programadas' ||
            c.key === 'Canceladas',
        )}
      </Legend.Root>
    );
  }, []);

  if (!data || total <= 0) {
    return (
      <div className={classes.noData}>
        <Info />
        <p>Sem dados disponíveis</p>
      </div>
    );
  }

  return (
    <Paper className={classes.activityStatusChart}>
      <Chart data={chartData} height={190}>
        <Palette scheme={colors} />
        <Legend position="right" rootComponent={LabelRoot} />
        <PieSeries valueField="value" argumentField="legend" />
        <EventTracker />
        <Animation />
        <Tooltip
          overlayComponent={TooltipOverlay}
          contentComponent={TooltipContent}
        />
      </Chart>
    </Paper>
  );
};

export default ChartActivityStatus;
